<template>
  <v-navigation-drawer
    v-model="modelValue"
    :width="width"
    :right="right"
    :left="left"
    :color="color"
    style="z-index: 999"
    temporary
    app
    @input="handleChangeModel"
  >
    <template v-if="!hideHeader" slot="prepend">
      <slot name="header">
        <div class="d-flex align-center relative py-4 px-4">
          <v-btn
            class="btn"
            color="white"
            absolute
            plain
            small
            left
            @click="cancel"
          >
            <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-arrow-left</v-icon>

            <span v-if="$vuetify.breakpoint.smAndUp"> Voltar </span>
          </v-btn>

          <v-spacer />

          <div class="text-body-1 font-weight-bold">{{ title }}</div>

          <v-spacer />
        </div>
      </slot>
    </template>

    <div class="px-4">
      <slot name="content"></slot>
    </div>

    <template v-if="!hideFooter" slot="append">
      <slot name="footer">
        <div class="d-flex align-center py-2 px-4">
          <v-spacer />

          <v-btn class="btn mr-2" color="white" plain @click="cancel">
            Cancelar
          </v-btn>

          <v-btn
            class="btn"
            color="primary"
            :disabled="disabledConfirm"
            @click="confirm"
          >
            Confirmar
          </v-btn>
        </div>
      </slot>
    </template>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "SideDrawer",

  props: {
    value: {
      type: Boolean,
      required: true,
    },

    title: {
      type: String,
      default: "",
    },

    color: {
      type: String,
      default: "neutral",
    },

    width: {
      type: [String, Number],
      default: "480",
    },

    right: {
      type: Boolean,
      default: true,
    },

    left: {
      type: Boolean,
      default: false,
    },

    hideHeader: {
      type: Boolean,
      default: false,
    },

    hideFooter: {
      type: Boolean,
      default: false,
    },

    disabledConfirm: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("update:value", newValue);
      },
    },
  },

  methods: {
    confirm() {
      this.$emit("confirm");
    },

    cancel() {
      this.$emit("cancel");
    },

    handleChangeModel(event) {
      if (!event) this.cancel();

      this.$emit("update:value", event);
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
